import { Link } from 'react-router-dom';
import { getHotStories } from '@/lib/content';

export default function HeroSection() {
  const hot = getHotStories(4);
  const lead = hot[0];
  const rest = hot.slice(1, 4);

  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-6">
            <span className="inline-flex items-center gap-2 rounded-md border border-accent-300 bg-accent-100 px-3 py-1.5 font-label text-xs font-medium text-accent-900">
              <i className="ri-flashlight-line text-sm" aria-hidden="true"></i>
              今日速览已更新 24 条
            </span>

            <h1 className="mt-5 font-heading text-3xl font-black leading-[1.2] tracking-tight text-foreground-950 md:text-5xl">
              5看料网 · 三分钟看完全网热点
            </h1>

            <p className="mt-5 max-w-xl font-body text-sm leading-relaxed text-foreground-600 md:text-base">
              我们用速览、快看与精简摘要，把冗长的爆料和热点压缩成可读的要点。打开即看，读完即懂，通勤路上也能掌握今天的关键信息。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/hot"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-book-open-line text-base" aria-hidden="true"></i>
                浏览今日速览
              </Link>
              <a
                href="#summary"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 font-label text-sm font-medium text-foreground-800 transition-colors hover:border-secondary-400 hover:text-secondary-700"
              >
                <i className="ri-layout-grid-line text-base" aria-hidden="true"></i>
                了解速览模式
              </a>
            </div>

            <dl className="mt-9 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
              <div>
                <dt className="font-body text-xs text-foreground-500">今日更新</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-primary-600">24 条</dd>
              </div>
              <div>
                <dt className="font-body text-xs text-foreground-500">覆盖板块</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-foreground-950">6 大</dd>
              </div>
              <div>
                <dt className="font-body text-xs text-foreground-500">平均阅读</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-foreground-950">3 分钟</dd>
              </div>
            </dl>
          </div>

          <div className="lg:col-span-6">
            <Link
              to={`/article/${lead.id}`}
              className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="relative h-[240px] w-full overflow-hidden bg-background-200 md:h-[320px]">
                <img
                  src={lead.cover}
                  alt={lead.coverAlt}
                  title={`${lead.title} - 5看料网速览`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
                <div className="absolute inset-x-0 bottom-0 p-5">
                  <span className="rounded-md bg-accent-500 px-2.5 py-1 font-label text-xs font-medium text-primary-950">
                    今日头条
                  </span>
                  <h2 className="mt-3 font-heading text-lg font-bold leading-snug text-background-50 md:text-xl">
                    {lead.title}
                  </h2>
                </div>
              </div>
            </Link>

            <ul className="mt-4 flex flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {rest.map((story) => (
                <li key={story.id}>
                  <Link to={`/article/${story.id}`} className="flex items-center gap-3 p-3 md:p-4">
                    <span className="h-14 w-20 shrink-0 overflow-hidden rounded-md bg-background-200">
                      <img
                        src={story.cover}
                        alt={story.coverAlt}
                        title={`${story.title} - 5看料网速览`}
                        className="h-full w-full object-cover object-top"
                      />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate font-heading text-sm font-semibold text-foreground-950 transition-colors hover:text-primary-600">
                        {story.title}
                      </span>
                      <span className="mt-1 flex items-center gap-2 font-label text-xs text-foreground-500">
                        <span>{story.categoryName}</span>
                        <span aria-hidden="true">·</span>
                        <span className="flex items-center gap-1">
                          <i className="ri-fire-line text-sm text-accent-600" aria-hidden="true"></i>
                          {story.heat}
                        </span>
                      </span>
                    </span>
                    <i className="ri-arrow-right-s-line shrink-0 text-xl text-foreground-400" aria-hidden="true"></i>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}